interface MaturityDateEditableParams {
  indexType: string | null | undefined
  isAmendment: boolean | undefined
  isEdit: boolean | undefined
}

/**
 * Decides whether the loan maturity (end) date field is editable.
 *
 * Amendments and edits always allow the maturity date to change. For new loan
 * creation the field is editable for Term and Overnight (O/N) rates; other
 * non-term rates (Floating, Fixed) stay locked to the facility maturity date.
 */
export const isMaturityDateEditable = ({
  indexType,
  isAmendment,
  isEdit,
}: MaturityDateEditableParams): boolean => {
  if (isAmendment || isEdit) {
    return true
  }

  return indexType === 'TermIndex' || indexType === 'OvernightIndex'
}

interface NonTermMaturityDateParams {
  isEditable: boolean
  currentEndDate: Date | null
  facilityMaturity: Date | null
}

/**
 * Decides the maturity (end) date the form should hold when a non-term index
 * rate is selected.
 *
 * Locked rates (Floating, Fixed) are always pinned to the facility maturity
 * date. Editable rates (Overnight) default to the facility maturity date but
 * preserve a date the user already picked — matching how Term behaves.
 */
export const resolveNonTermMaturityDate = ({
  isEditable,
  currentEndDate,
  facilityMaturity,
}: NonTermMaturityDateParams): Date | null => {
  if (!isEditable) {
    return facilityMaturity
  }

  return currentEndDate ?? facilityMaturity
}
